module.exports = __webpack_public_path__ + "img/preview_hlpartners.257660c0.gif";